/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Organization-User specific serializer that is limited to the Organization-User
 * specific fields.
 * @export
 * @interface APIOrgUser
 */
export interface APIOrgUser {
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    readonly self: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIOrgUser
     */
    readonly isOrgAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIOrgUser
     */
    readonly isSuperuser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIOrgUser
     */
    readonly isStaff: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    readonly organization: string;
    /**
     * 
     *             <ul style="list-style=none;">
     *                 <li>Required for organization users, as the email is used as the username.</li>
     *                 <li>Guest users do *not* require an email address.</li>
     *             </ul>
     *             
     * @type {string}
     * @memberof APIOrgUser
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    readonly firstName: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    readonly lastName: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    comment?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIOrgUser
     */
    readonly preferences: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof APIOrgUser
     */
    createdAt?: Date;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof APIOrgUser
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUser
     */
    readonly roles: string;
}

/**
 * Check if a given object implements the APIOrgUser interface.
 */
export function instanceOfAPIOrgUser(value: object): value is APIOrgUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('isOrgAdmin' in value) || value['isOrgAdmin'] === undefined) return false;
    if (!('isSuperuser' in value) || value['isSuperuser'] === undefined) return false;
    if (!('isStaff' in value) || value['isStaff'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('preferences' in value) || value['preferences'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function APIOrgUserFromJSON(json: any): APIOrgUser {
    return APIOrgUserFromJSONTyped(json, false);
}

export function APIOrgUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrgUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'self': json['self'],
        'isOrgAdmin': json['is_org_admin'],
        'isSuperuser': json['is_superuser'],
        'isStaff': json['is_staff'],
        'organization': json['organization'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'preferences': json['preferences'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'roles': json['roles'],
    };
}

export function APIOrgUserToJSON(value?: Omit<APIOrgUser, 'id'|'self'|'is_org_admin'|'is_superuser'|'is_staff'|'organization'|'first_name'|'last_name'|'preferences'|'roles'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'comment': value['comment'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'is_active': value['isActive'],
    };
}

